import React, { useEffect, useMemo, useState } from "react";
import { SectionCard } from "../../../Component/RetailerMainComponents/SectionCard";
import SimpleTable from "../../../Component/Common/SimpleTable";
import RegularLoader from "../../../Component/Loader/RegularLoader";
import RefreshButton from "../../../Component/Common/RefreshButton";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../../config/api";
import CustomerProfileCard from "./CustomerProfileCard";
import Pagination from "../../../Component/Common/Pagination";

export default function CustomerList({ entityType = null, entityId = null }) {
  const navigate = useNavigate();

  const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
  const userRole = authUser?.role;
  const sessionId = authUser?.id;

  const isRetailerMobile =
  window.innerWidth < 640 && userRole === 5;

  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  /* ---------------- BUILD QUERY PARAMS ---------------- */
  const buildQueryParams = () => {
    if (entityType && entityId) {
      if (entityType === "company") return `company_id=${entityId}`;
      if (entityType === "agent") return `agent_id=${entityId}`;
      if (entityType === "retailer") return `retailer_id=${entityId}`;
    }

    if (userRole === 2) return `company_id=${sessionId}`;
    if (userRole === 4) return `agent_id=${sessionId}`;
    if (userRole === 5) return `retailer_id=${sessionId}`;
    if (userRole === 6) return `created_by=${sessionId}`;

    return "";
  };

  /* ---------------- FETCH ---------------- */
  const fetchCustomers = async () => {
    try {
      setLoading(true);

      const filterParam = buildQueryParams();
      const url = `${BASE_URL}warranty/get-customers?page=${page}${
        filterParam ? `&${filterParam}` : ""
      }`;

      const res = await fetch(url);
      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Failed to fetch customers");
      }

      setCustomers(json.data || []);
      setTotalPages(json.last_page || 1);
    } catch (err) {
      console.error("Customer fetch failed:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, [page, entityType, entityId]);

  /* ---------------- TABLE ROWS ---------------- */
  const rows = useMemo(() => {
    return customers.map((c) => ({
      raw: c,
      cells: [
        c.name || "-",
        c.mobile || "-",
        c.email || "-",
        `${c.city || "-"}, ${c.state || "-"}`,
        c.pincode || "-",
        c.devices?.length || 0,
      ],
    }));
  }, [customers]);

  const hasData = customers.length > 0;

  /* ---------------- UI ---------------- */
  return (
    <SectionCard
      isRetailerMobile={isRetailerMobile}
      title="Customers"
      className={
        isRetailerMobile
          ? "bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
          : ""
      }
      right={
        <div className="hidden md:block">
          <RefreshButton onClick={() => fetchCustomers()} />
        </div>
      }
    >
      {/* LOADING */}
      {loading && (
        <div className="py-8 flex justify-center">
          <RegularLoader />
        </div>
      )}

      {/* NO DATA */}
      {!loading && !hasData && (
        <div
          className={`
            flex flex-col items-center justify-center py-10 text-center rounded-2xl
            ${
              isRetailerMobile
                ? "bg-white/10 backdrop-blur-xl border border-white/30 text-slate-900"
                : ""
            }
          `}
        >
          <p className="text-sm font-semibold text-slate-600">
            No customers found
          </p>
          <p className="mt-1 text-xs text-slate-500">
            Customers will appear here once they are added.
          </p>
        </div>
      )}

      {/* ================= MOBILE CARDS ================= */}
      {!loading && hasData && (
        <>
          <div className="grid gap-4 md:hidden">
            {customers.map((c) => (
              <CustomerProfileCard key={c.id} customer={c} />
            ))}
          </div>

          {/* MOBILE PAGINATION */}
          {totalPages > 1 && (
            <div className="mt-4 md:hidden">
              <Pagination
                currentPage={page}
                totalPages={totalPages}
                onPageChange={(p) => setPage(p)}
              />
            </div>
          )}
        </>
      )}


      {/* ================= DESKTOP TABLE ================= */}
      {!loading && hasData && (
        <div className="hidden md:block">
          <SimpleTable
            headers={[
              "Customer Name",
              "Mobile",
              "Email",
              "City / State",
              "Pincode",
              "Total Devices",
            ]}
            rows={rows}
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
            showSrNo
            renderActions={(row) => (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/customer-details/${row.id}`);
                }}
                className="px-3 py-1 text-xs bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                View
              </button>
            )}
          />
        </div>
      )}
    </SectionCard>
  );
}


// import React, { useEffect, useMemo, useState } from "react";
// import { SectionCard } from "../../../Component/RetailerMainComponents/SectionCard";
// import SimpleTable from "../../../Component/Common/SimpleTable";
// import RegularLoader from "../../../Component/Loader/RegularLoader";
// import RefreshButton from "../../../Component/Common/RefreshButton";
// import { useNavigate } from "react-router-dom";
// import { BASE_URL } from "../../../config/api";

// export default function CustomerList({ entityType = null, entityId = null }) {
//   const navigate = useNavigate();

//   const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
//   const userRole = authUser?.role;
//   const sessionId = authUser?.id;

//   const [customers, setCustomers] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   /* ---------------- BUILD QUERY PARAMS ---------------- */
//   const buildQueryParams = () => {
//     if (entityType && entityId) {
//       if (entityType === "company") return `company_id=${entityId}`;
//       if (entityType === "agent") return `agent_id=${entityId}`;
//       if (entityType === "retailer") return `retailer_id=${entityId}`;
//     }

//     if (userRole === 2) return `company_id=${sessionId}`;
//     if (userRole === 4) return `agent_id=${sessionId}`;
//     if (userRole === 5) return `retailer_id=${sessionId}`;

//     return "";
//   };

//   /* ---------------- FETCH ---------------- */
//   const fetchCustomers = async () => {
//     try {
//       setLoading(true);

//       const filterParam = buildQueryParams();
//       const url = `${BASE_URL}warranty/get-customers?page=${page}${
//         filterParam ? `&${filterParam}` : ""
//       }`;

//       const res = await fetch(url);
//       const json = await res.json();

//       if (!res.ok) {
//         throw new Error(json?.message || "Failed to fetch customers");
//       }

//       setCustomers(json.data || []);
//       setTotalPages(json.last_page || 1);
//     } catch (err) {
//       console.error("Customer fetch failed:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCustomers();
//   }, [page, entityType, entityId]);

//   /* ---------------- TABLE ROWS ---------------- */
//   const rows = useMemo(() => {
//     return customers.map((c) => ({
//       raw: c,
//       cells: [
//         c.name || "-",
//         c.mobile || "-",
//         c.email || "-",
//         `${c.city || "-"}, ${c.state || "-"}`,
//         c.pincode || "-",
//         c.devices?.length || 0,
//       ],
//     }));
//   }, [customers]);

//   const hasData = rows.length > 0;

//   /* ---------------- UI ---------------- */
//   return (
//     <SectionCard
//       title="Customers"
//       right={<RefreshButton onClick={fetchCustomers} />}
//     >
//       {/* LOADING */}
//       {loading && (
//         <div className="py-8 flex justify-center">
//           <RegularLoader />
//         </div>
//       )}

//       {/* NO DATA */}
//       {!loading && !hasData && (
//         <div className="flex flex-col items-center justify-center py-10 text-center">
//           <p className="text-sm font-semibold text-slate-600">
//             No customers found
//           </p>
//           <p className="mt-1 text-xs text-slate-500">
//             Customers will appear here once they are added.
//           </p>
//         </div>
//       )}

//       {/* TABLE */}
//       {!loading && hasData && (
//         <SimpleTable
//           headers={[
//             "Customer Name",
//             "Mobile",
//             "Email",
//             "City / State",
//             "Pincode",
//             "Total Devices",
//           ]}
//           rows={rows}
//           currentPage={page}
//           totalPages={totalPages}
//           onPageChange={setPage}
//           showSrNo
//           renderActions={(row) => (
//             <button
//               onClick={(e) => {
//                 e.stopPropagation();
//                 navigate(`/customer-details/${row.id}`);
//               }}
//               className="px-3 py-1 text-xs bg-blue-600 text-white rounded-md hover:bg-blue-700"
//             >
//               View
//             </button>
//           )}
//         />
//       )}
//     </SectionCard>
//   );
// }



// import React, { useEffect, useMemo, useState } from "react";
// import { SectionCard } from "../../../Component/RetailerMainComponents/SectionCard";
// import SimpleTable from "../../../Component/Common/SimpleTable";
// import RegularLoader from "../../../Component/Loader/RegularLoader";
// import RefreshButton from "../../../Component/Common/RefreshButton";
// import Pagination from "../../../Component/Common/Pagination";
// import { useNavigate } from "react-router-dom";
// import { BASE_URL } from "../../../config/api";

// export default function CustomerList({ entityType = null, entityId = null }) {
//   const navigate = useNavigate();

//   const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
//   const userRole = authUser?.role;
//   const sessionId = authUser?.id;

//   const [customers, setCustomers] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   /* ---------------- BUILD QUERY PARAMS ---------------- */
//   const buildQueryParams = () => {
//     // 🧩 Entity override (UserDetails flow)
//     if (entityType && entityId) {
//       if (entityType === "company") return `company_id=${entityId}`;
//       if (entityType === "agent") return `agent_id=${entityId}`;
//       if (entityType === "retailer") return `retailer_id=${entityId}`;
//     }

//     // 🔐 Fallback → logged-in role
//     if (userRole === 2) return `company_id=${sessionId}`;
//     if (userRole === 4) return `agent_id=${sessionId}`;
//     if (userRole === 5) return `retailer_id=${sessionId}`;

//     // Admin → no filter
//     return "";
//   };

//   /* ---------------- FETCH ---------------- */
//   const fetchCustomers = async () => {
//     try {
//       setLoading(true);

//       const filterParam = buildQueryParams();
//       const url = `${BASE_URL}warranty/get-customers?page=${page}${
//         filterParam ? `&${filterParam}` : ""
//       }`;

//       const res = await fetch(url);
//       const json = await res.json();

//       if (!res.ok) {
//         throw new Error(json?.message || "Failed to fetch customers");
//       }

//       setCustomers(json.data || []);
//       setTotalPages(json.last_page || 1);
//     } catch (err) {
//       console.error("Customer fetch failed:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCustomers();
//   }, [page, entityType, entityId]);

//   /* ---------------- TABLE ROWS ---------------- */
//   const rows = useMemo(() => {
//     return customers.map((c) => ({
//       raw: c,
//       cells: [
//         c.name || "-",
//         c.mobile || "-",
//         c.email || "-",
//         `${c.city || "-"}, ${c.state || "-"}`,
//         c.pincode || "-",
//         c.devices?.length || 0,
//       ],
//     }));
//   }, [customers]);

//   /* ---------------- UI ---------------- */
//   return (
//     <SectionCard
//       title="Customers"
//       right={<RefreshButton onClick={fetchCustomers} />}
//     >
//       {loading ? (
//         <div className="py-8 flex justify-center">
//           <RegularLoader />
//         </div>
//       ) : (
//         <SimpleTable
//           headers={[
//             "Customer Name",
//             "Mobile",
//             "Email",
//             "City / State",
//             "Pincode",
//             "Total Devices",
//           ]}
//           rows={rows}
//           currentPage={page}
//           totalPages={totalPages}
//           onPageChange={setPage}
//           showSrNo
//           renderActions={(row) => (
//             <button
//               onClick={(e) => {
//                 e.stopPropagation();
//                 navigate(`/customer-details/${row.id}`);
//               }}
//               className="px-3 py-1 text-xs bg-blue-600 text-white rounded-md hover:bg-blue-700"
//             >
//               View
//             </button>
//           )}
//         />
//       )}
//     </SectionCard>
//   );
// }
